/* eslint-disable */

import generateUuid from 'uuid/v4'
import { store } from '../stores'

import { isTestMode } from '../VNAndroidSDK/Utils'

import { invoiceNumber } from './orderNumbers'
import { getNetworkAvailableValue } from './networkConnected'

import { ERRORS_WITH_DESCRIPTIONS } from '../VNSyncManager/containers/VNSyncManager'

export const fakeSuccessResponse = (
  uuid,
  orderNumber,
  hRef,
  amount,
  tipAmount,
  tipEnabled,
  mcAnimationEnabled,
  deviceSerial,
  forceNetworkOverride,
  bridgeMethod,
) => {
  const orderInvoiceNumber = hRef || invoiceNumber(orderNumber)
  const networkOnline = forceNetworkOverride || getNetworkAvailableValue()

  return {
    amount: amount || '0.00',
    reasonText: 'OK',
    tipAmount: tipAmount || '0.00',
    merchantReferenceCode: orderInvoiceNumber,
    tokenInformation: {
      tokenExpiration: '1231',
      cardExpirationMonth: '12',
      cardExpirationYear: '31',
      token: '8045771714357049',
    },
    transId: orderInvoiceNumber,
    cardType: 'VISA',
    responseName: 'onSuccess',
    message: 'Approved',
    receiptData: {
      approvalCode: 'A',
      maskedPan: '123400000001234',
      authStatus: 'Approved',
      maskedCardNumber: '7049',
    },
    uuid: uuid || generateUuid(),
    cardIssuer: 'VISA DEBIT',
    authResponse: {
      authorizationCode: '478645',
      processorTransactionId: '1920108221202409170832093926',
      reconciliationId: '6FFDC0817446EE7C',
    },
    isOfflineApproval: !networkOnline,
    transType: bridgeMethod ? bridgeMethod : 'sale',
    requestId: orderInvoiceNumber,
    cardholderName: 'VALUED CUSTOMER',
    invoiceNumber: orderInvoiceNumber,
    reasonCode: '000000',
    status: networkOnline ? 'ACCEPT' : 'APPROVED OFFLINE',
  }
}

const fakeSuccessAuthResponse = (uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial) => {
  const orderInvoiceNumber = hRef || invoiceNumber(orderNumber)
  const networkOnline = getNetworkAvailableValue()

  return {
    amount: amount || '0.00',
    reasonText: 'OK',
    tipAmount: tipAmount || '0.00',
    merchantReferenceCode: orderInvoiceNumber,
    tokenInformation: {
      tokenExpiration: '1231',
      cardExpirationMonth: '12',
      cardExpirationYear: '31',
      token: '8045771714357049',
    },
    transId: orderInvoiceNumber,
    cardType: 'VISA',
    responseName: 'onSuccess',
    message: 'Approved',
    receiptData: {
      approvalCode: 'A',
      maskedPan: '123400000001234',
      authStatus: 'Approved',
      maskedCardNumber: '7049',
    },
    uuid: uuid || generateUuid(),
    cardIssuer: 'VISA DEBIT',
    authResponse: {
      authorizationCode: '478645',
      processorTransactionId: '1920108221202409170832093926',
      reconciliationId: '6FFDC0817446EE7C',
    },
    isOfflineApproval: !networkOnline,
    transType: 'auth',
    requestId: orderInvoiceNumber,
    cardholderName: 'VALUED CUSTOMER',
    invoiceNumber: orderInvoiceNumber,
    reasonCode: '000000',
    status: networkOnline ? 'ACCEPT' : 'APPROVED OFFLINE',
  }
}

const fakeDeclineResponse = (uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial) => {
  const orderInvoiceNumber = hRef || invoiceNumber(orderNumber)

  return {
    amount: amount || '0.00',
    reasonText: 'DECLINE',
    tipAmount: tipAmount || '0.00',
    merchantReferenceCode: orderInvoiceNumber,
    tokenInformation: {
      tokenExpiration: '1231',
      cardExpirationMonth: '12',
      cardExpirationYear: '31',
      token: '4479289dn3r6bh24',
    },
    transId: orderInvoiceNumber,
    cardType: 'VISA',
    responseName: 'onSuccess',
    message: 'Host Declined',
    receiptData: {
      approvalCode: 'D',
      maskedPan: '',
      authStatus: 'Host Declined',
      maskedCardNumber: '4479',
    },
    uuid: uuid || generateUuid(),
    cardIssuer: 'VISA DEBIT',
    authResponse: {
      authorizationCode: '',
      processorTransactionId: '2620016291202409222352210941',
      reconciliationId: '2CB720C803024F56',
    },
    isOfflineApproval: false,
    transType: 'sale',
    requestId: orderInvoiceNumber,
    cardholderName: ' /',
    invoiceNumber: orderInvoiceNumber,
    reasonCode: '000100',
    status: 'DECLINED',
  }
}

const fakeSuccessStatusResponse = (requestId) => {
  console.log('Fake status response for requestId:', requestId)

  return {
    requestId: requestId,
    refNum: '154',
    invoiceNumber: requestId,
    message: 'APPROVED',
    reasonText: 'OK',
    // Other fields that may be present but should be unused:
    // amount: "115.14",
    // serialNumber: "2620003443",
    // tipAmount: "0.0",
    // merchantReferenceCode: "2148493096",
    // tokenInformation: {
    //     tokenExpiration: "1225",
    //     cardExpirationMonth: "12",
    //     cardExpirationYear: "25",
    //     token: "8053843003300011"
    // },
    // transId: "2148493096",
    // cardType: "MASTERCARD",
    // receiptData: {
    //     approvalCode: "A",
    //     authStatus: "APPROVED",
    //     maskedCardNumber: "0011"
    // },
    // cardIssuer: "MASTERCARD",
    // authResponse: {
    //     authorizationCode: "OK228Z",
    //     processorTransactionId: "2620003443202410161113488278",
    //     reconciliationId: "4DF87D95F76A993D"
    // },
    // isOfflineApproval: false,
    // mcAnimationEnabled: false,
    // cardholderName: "UAT USA/Test Card 08      ",
    // reasonCode: "000000",
    // batchNumber: "1",
    // status: "OK"
  }
}

const fakeSuccessSafUploadResponse = () => {
  console.log('Fake SAF upload response: Success')

  return {
    resultText: 'OK',
    rawResult: 'OK',
    fullResponse: {
      SAFUploadedCount: '0',
      SAFFailedCount: '0',
      SAFTotalAmount: '0',
      SAFFailedTotal: '0',
      SAFDeletedCount: '',
      SAFTotalCount: '0',
      Message: '',
      resultCode: '',
      resultTxt: '',
      // Other fields that may be present but should be unused:
      // CreditAmount": "",
      // CHECKCount: "",
      // Timestamp: "",
      // ResultTxt: "OK",
      // GiftAmount: "",
      // SAFUploadedAmount: "0",
      // TORResponseInfo: {
      //     HostResponseCode: "",
      //     OrigAmount: "",
      //     OrigTransAuthCode: "",
      //     BatchNo: "",
      //     HostReferenceNumber: "",
      //     OrigTransType: "",
      //     ReversalAuthCode: "",
      //     ReversalTimeStamp: "",
      //     RecordType: "",
      //     GatewayTransactionID: "",
      //     MaskedPAN: "",
      //     OrigTransDateTime: "",
      //     HostResponseMessage: ""
      // },
      // BatchNum: "",
      // CHECKAmount: "",
      // HostResponse: "",
      // HostTraceNum: "",
      // DebitCount: "",
      // ExtData: "",
      // AuthCode: "",
      // EBTAmount: "",
      // MultiMerchant: {
      //     Id: "",
      //     Name: ""
      // },
      // MID: "",
      // BatchFailedRefNum: "",
      // TID: "",
      // LoyaltyAmount: "",
      // LoyaltyCount: "",
      // GiftCount: "",
      // BatchFailedCount: "",
      // CashCount: "",
      // DebitAmount: "",
      // HostCode: "",
      // CashAmount: "",
      // ResultCode: "000000",
      // CreditCount: "",
      // EBTCount: ""
    },
  }
}

const fakeFailureSafUploadResponse = () => {
  console.log('Fake SAF upload response: Failure')

  const randomError =
    Object.keys(ERRORS_WITH_DESCRIPTIONS)[Math.floor(Math.random() * Object.keys(ERRORS_WITH_DESCRIPTIONS).length)]

  return {
    resultText: randomError,
    rawResult: 'NULL',
    fullResponse: 'NULL',
  }
}

class FakePeripheralBridge {
  static handlers = {
    saveConfig: async (config, callback) => {
      console.log('Fake save config:', config)
      callback({ success: true })
    },
    getBuildInfo: async (unused, callback) => {
      /*
        Data is returned as from the APK:
          var applicationId: String? = null,
          var versionName: String? = null,
          var versionCode: Int? = null,
          var paymentType: String? = null,
          var posURL: String? = null,
          var deviceModel: String? = null,
          var deviceFirmwareVersion: String? = null,
          var paymentSoftwareAppName: String? = null,
          var paymentSoftwareVersion: String? = null,
          var paymentFirmwareVersion: String? = null,
          var paymentSDKVersion: String? = null,
          var paymentCommType: String? = null,
          var paymentDeviceSN: String? = null,

        Here we just generate some fake data.
      */
      callback({
        applicationId: 'com.venuenext.arena',
        paymentType: 'pax',
        posURL: window.location.href,
        versionName: 'v2.20.3',
        versionCode: 2203,
        deviceModel: 'Web Simulator',
        deviceFirmwareVersion: '1.0.0',
        paymentSoftwareAppName: 'PAX Web Simulator',
        paymentSoftwareVersion: '1.0.0',
        paymentFirmwareVersion: '1.0.0',
        paymentSDKVersion: '1.0.0',
        paymentCommType: 'Web Bridge',
        paymentDeviceSN: window.localStorage.getItem('device_id') || generateUuid(),
      })
    },
    getSerialNumber: async (unused, callback) => {
      // Wait a random amount of time between 100ms and 1.5 seconds to simulate latency.
      await new Promise((resolve) => setTimeout(resolve, Math.random() * 1400 + 100))

      callback(window.localStorage.getItem('device_id') || generateUuid())
    },
    executeSaleRequest: async (
      { uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, sensoryBrandingEnabled, deviceSerial },
      callback,
    ) => {
      // Wait a random amount of time between 1 and 3 seconds to simulate network latency.
      await new Promise((resolve) => setTimeout(resolve, Math.random() * 2000 + 1000))

      let response
      if (store.getState().VNTestMode.cardReaderError) {
        response = fakeDeclineResponse(uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial)
      } else {
        response = fakeSuccessResponse(uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial)
      }

      this.handlers['handleResult'](response, () => {})
      callback(response)
    },
    executeAuthRequest: async (
      { uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, sensoryBrandingEnabled, deviceSerial },
      callback,
    ) => {
      // Wait a random amount of time between 1 and 3 seconds to simulate network latency.
      await new Promise((resolve) => setTimeout(resolve, Math.random() * 2000 + 1000))

      let response
      if (store.getState().VNTestMode.cardReaderError) {
        response = fakeDeclineResponse(uuid, orderNumber, hRef, amount, tipAmount, tipEnabled, mcAnimationEnabled, deviceSerial)
      } else {
        response = fakeSuccessResponse(
          uuid,
          orderNumber,
          hRef,
          amount,
          tipAmount,
          tipEnabled,
          mcAnimationEnabled,
          deviceSerial,
          false,
          'auth',
        )
      }

      this.handlers['handleResult'](response, () => {})
      callback(response)
    },
    checkStatus: async ({ requestId }, callback) => {
      // Wait a random amount of time between 1 and 3 seconds to simulate network latency.
      await new Promise((resolve) => setTimeout(resolve, Math.random() * 2000 + 1000))

      const response = fakeSuccessStatusResponse(requestId)

      callback(response)
    },
    getSafMode: async (unused, callback) => {
      const networkOnline = getNetworkAvailableValue()

      callback(networkOnline ? '3' : '2')
    },
    replayRequests: async (unused, callback) => {
      // Wait a random amount of time between 5 and 15 seconds to simulate network latency.
      await new Promise((resolve) => setTimeout(resolve, Math.random() * 10000 + 5000))

      console.log('Replaying requests...')

      callback(Math.random() > 0.2 ? fakeSuccessSafUploadResponse() : fakeFailureSafUploadResponse())
    },
  }

  static runHandler = (handlerName, data, callback) => {
    if (!this.handlers || !this.handlers[handlerName]) return

    this.handlers[handlerName](data, callback)
  }

  static getBridge() {
    return {
      call: (method, data, callback = () => {}) => this.runHandler(method, data, callback),
      callHandler: (handlerName, data, callback = () => {}) => this.runHandler(handlerName, data, callback),
      registerHandler: (handlerName, handler) => {
        this.handlers[handlerName] = handler
      },
    }
  }
}

export default class PeripheralBridge {
  static setupWebViewJavascriptBridge = (callback) => {
    if (window.WebViewJavascriptBridge) return callback(window.WebViewJavascriptBridge)
    if (window.VNCallbacks) return window.VNCallbacks.push(callback)

    window.VNCallbacks = [callback]

    var VNIframe = document.createElement('iframe')
    VNIframe.style.display = 'none'
    VNIframe.src = 'vnscheme://__BRIDGE_LOADED__'

    document.documentElement.appendChild(VNIframe)

    setTimeout(function () {
      document.documentElement.removeChild(VNIframe)
    }, 0)
  }

  static getBridge() {
    if (isTestMode()) return FakePeripheralBridge.getBridge()

    return window?.WebViewJavascriptBridge
  }
}
